export const BRAND = {
  name: "Akshar Investments",
  tagline: "Your partner in wealth creation",
  owner: "Parimal Mistry",
  phone: "+91 99099 93109",
  phoneHref: "tel:+919909993109",
  whatsappHref: "https://wa.me/919909993109",
  email: "parimal@aksharinvestments.in",
  address:
    "261 - Second Floor, Central Bazar, Opp. Vidyakunj School, Gandevi Road, Navsari - 396445",
  logo: "https://customer-assets.emergentagent.com/job_goal-guided-finance/artifacts/4irpgi2r_logo.png",
  ownerPhoto:
    "https://customer-assets.emergentagent.com/job_36fc1972-2462-46dd-8204-713b9bb9adcc/artifacts/ar6a7ugj_WhatsApp%20Image%202026-04-25%20at%2010.30.12%20PM.jpeg",
};

export const GOALS = [
  {
    id: "retirement",
    title: "Retirement Planning",
    blurb:
      "Live your golden years with dignity. We engineer income streams that outlive market cycles.",
    image: "https://images.pexels.com/photos/19811308/pexels-photo-19811308.jpeg",
    span: "lg:col-span-6 lg:row-span-2",
    accent: "Long horizon",
  },
  {
    id: "child-education",
    title: "Child Education",
    blurb:
      "From IIT to Ivy League — invest today for the degree that opens every door tomorrow.",
    image:
      "https://images.unsplash.com/photo-1758612898701-e2f2958f219d?crop=entropy&cs=srgb&fm=jpg&w=1400",
    span: "lg:col-span-6",
    accent: "Inflation-beating",
  },
  {
    id: "vacation",
    title: "Plan a Vacation",
    blurb:
      "Goa next winter. Switzerland in '27. The world rewards the well-planned traveller.",
    image: "https://images.pexels.com/photos/36758154/pexels-photo-36758154.jpeg",
    span: "lg:col-span-3",
    accent: "Short term",
  },
  {
    id: "wealth",
    title: "Wealth Creation",
    blurb:
      "Disciplined SIPs. Diversified equity. The compounding engine that built Indian dynasties.",
    image: "https://images.pexels.com/photos/11391951/pexels-photo-11391951.jpeg",
    span: "lg:col-span-3",
    accent: "Compound power",
  },
  {
    id: "home",
    title: "Buying Home",
    blurb:
      "Down-payment ready in 5 years. We map every EMI to your earning curve.",
    image: "https://images.pexels.com/photos/8134846/pexels-photo-8134846.jpeg",
    span: "lg:col-span-6",
    accent: "Asset building",
  },
  {
    id: "emergency",
    title: "Emergency Funds",
    blurb:
      "Six months of expenses. Liquid. Protected. Earning. Sleep with peace.",
    image: "https://images.pexels.com/photos/3943727/pexels-photo-3943727.jpeg",
    span: "lg:col-span-6",
    accent: "Safety first",
  },
];

export const SERVICES = [
  { icon: "TrendingUp", title: "Mutual Funds", desc: "Direct & Regular plans across equity, debt, hybrid — built around your risk." },
  { icon: "ShieldCheck", title: "Life & Health Insurance", desc: "IRDAI-licensed advice on the right cover for your family's tomorrow." },
  { icon: "Banknote", title: "Fixed Deposits & Bonds", desc: "Capital-safe instruments engineered for predictable income." },
  { icon: "Briefcase", title: "Portfolio Management (PMS)", desc: "Concentrated, professionally managed portfolios for HNIs." },
  { icon: "LineChart", title: "AIF & SIF", desc: "Sophisticated alternative investment funds for accredited investors." },
  { icon: "Globe2", title: "Gift City Investments", desc: "Onshore-offshore exposure through India's IFSC gateway." },
];

export const COMPLIMENTARY = [
  "30 Min Q&A",
  "Financial Goals Analysis",
  "Financial Health Check-up",
  "Mutual Fund Portfolio Review",
  "Insurance Portfolio Review",
  "Retirement Readiness Check",
  "Risk Profile Assessment",
  "Tax-Saving Review",
  "One-Page Financial Blueprint",
];

export const TESTIMONIALS = [
  {
    name: "Hardik Patel",
    role: "Software Engineer, Surat",
    quote:
      "Parimal sir explained mutual funds to my parents in Gujarati like nobody had before. Today my whole family invests through Akshar.",
  },
  {
    name: "Meera Shah",
    role: "Doctor, Navsari",
    quote:
      "The retirement plan was eye-opening. I no longer fear age 60 — I look forward to it.",
  },
  {
    name: "Rajesh Desai",
    role: "Business Owner, Valsad",
    quote:
      "18 years in the industry shows. Honest advice, no product pushing. Rare in this profession.",
  },
  {
    name: "Anjali Mehta",
    role: "Homemaker, Bilimora",
    quote:
      "Started a ₹5,000 SIP for my daughter's education. Akshar made the whole process feel safe and simple.",
  },
];
